import { render, staticRenderFns } from "./Landing.vue?vue&type=template&id=895a1c1c&scoped=true&"
import script from "./Landing.vue?vue&type=script&lang=js&"
export * from "./Landing.vue?vue&type=script&lang=js&"
import style0 from "./Landing.vue?vue&type=style&index=0&id=895a1c1c&lang=scss&scoped=true&"
import style1 from "./Landing.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "895a1c1c",
  null
  
)

export default component.exports